module.exports = __webpack_public_path__ + "static/img/2015100910563038.9286de8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2015100910563038.jpg
// module id = YeiX
// module chunks = 1